import styled from 'styled-components';

import colors from '../../../../../styles/colors';

const Container = styled.div`
  background-color: ${({ $isReady }) => ($isReady ? colors.base.gamma : 'transparent')};
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 60%;
  max-width: 700px;
  min-width: 500px;
  overflow-y: ${({ $isReady }) => ($isReady ? 'scroll' : 'hidden')};
  padding: 10px;
`;

const EmptyContainer = styled.div`
  display: flex;
  padding: 20px;
`;

const LoadingMore = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export {
  Container,
  EmptyContainer,
  LoadingMore,
};
